import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// ═══════════════════════════════════════════════════════════
// useWebhookSync — Manually trigger webhook event reconciliation
// Calls POST /api/admin/webhooks/sync to diff active rule
// triggers against registered_events_json and bind/unbind as needed.
// ═══════════════════════════════════════════════════════════

export function useWebhookSync() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.post<{ synced: boolean }>("/api/admin/webhooks/sync", {}),
    onSuccess: () => {
      // Refresh settings and live status so the UI reflects any changes
      void queryClient.invalidateQueries({ queryKey: queryKeys.settings });
      void queryClient.invalidateQueries({ queryKey: queryKeys.webhookStatus });
    },
  });
}
